<template>
    <div class="absolute bg-white rounded-b-md shadow-37 top-full left-0 w-full flex justify-center gap-4 -mt-4">
        <div v-if="status === 'pending'">
            <div class="flex items-center gap-6 justify-center p-4">
                <USkeleton v-for="i in 6" class="w-24 h-6" />
            </div>
        </div>
        <div v-else v-for="item in data" class="mt-4 relative group">
            <h3 class="peer p-2 hover:bg-amazon-50 rounded-sm transition-all">
                <NuxtLink :to="`/category/${item?.slug}`" class="flex items-center gap-2">
                    <UtilsDynamicIcon
                        v-if="item?.icon"
                        :icon="item?.icon"
                        class-name="w-5 h-5 fill-gray-400 text-gray-400"
                    />
                    <span>
                        {{ item?.name }}
                    </span>
                    <UButton
                        v-if="item?.children"
                        :padded="false"
                        icon="i-solar-alt-arrow-down-outline"
                        variant="link"
                        color="black"
                    />
                </NuxtLink>
            </h3>
            <div
                v-if="item?.children"
                class="absolute top-full bg-white w-48 left-1/2 -translate-x-1/2 shadow-86 rounded-md hidden group-hover:block transition-all"
            >
                <ul>
                    <li v-for="el in item?.children" class="hover:bg-amazon-200 transition-all rounded-md">
                        <NuxtLink :to="`/category/${item?.slug}/${el.slug}`" class="w-full block p-2">
                            <span>{{ el.name }}</span>
                        </NuxtLink>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { ICategory } from "~/libs/types/api/category";

const { data, status, error, refresh } = useLazyAsyncData<ICategory[]>(
    "categories-list",
    () =>
        fetchData("/category/list", {
            params: {
                include: "children",
            },
        }),
    {
        getCachedData(key, nuxtApp) {
            return nuxtApp.payload.data[key] || nuxtApp.static.data[key];
        },
    }
);
</script>

<style></style>
